export default "__VITE_ASSET__3b4cb6c6__"